// Constants
import OBJECT_ERROR from 'constants/newError.json';

// Services
import { errorsListApi } from 'services/apiDigitalTicket/errorList';

export const setDynamicErrorMessagersList = async () => {
  try {
    const { data, status } = await errorsListApi.get();
    const aux: { [key: string]: string } = {};
    if (Array.isArray(data)) {
      data.forEach((item) => {
        aux[item.id] = item.message;
      });
    }
    if (status === 200) {
      localStorage.setItem('errorMessagersList', JSON.stringify(aux));
    }
  } catch (error) {
    // Do nothing
  }
  return null;
};

export const errorMessagersList = (internalCode: string) => {
  const dynamicErrorMessagersList = JSON.parse(
    localStorage.getItem('errorMessagersList') || '{}',
  );
  if (
    dynamicErrorMessagersList[
      internalCode as keyof typeof dynamicErrorMessagersList
    ]
  ) {
    return dynamicErrorMessagersList[
      internalCode as keyof typeof dynamicErrorMessagersList
    ];
  }
  if (OBJECT_ERROR[internalCode as keyof typeof OBJECT_ERROR]) {
    return OBJECT_ERROR[internalCode as keyof typeof OBJECT_ERROR];
  }
  return OBJECT_ERROR['error.generic'];
};
